import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import {
  type GetCustomerContractedProducts200 as ContractedProducts,
  useGetCustomerContractedProducts
} from 'api';

import { useOrganisationId } from 'hooks/context';

type ContractedProductsContextProps = {
  contractedProducts: ContractedProducts | undefined;
};

const ContractedProductsContext = createContext(
  {} as ContractedProductsContextProps
);

type Props = {
  children: ReactNode;
};

export const ContractedProductsProvider = ({ children }: Props) => {
  const organisationId = useOrganisationId<number>();

  const { data } = useGetCustomerContractedProducts(organisationId);

  return (
    <ContractedProductsContext.Provider value={{ contractedProducts: data }}>
      {children}
    </ContractedProductsContext.Provider>
  );
};

export const useContractedProductsContext = () =>
  useContext(ContractedProductsContext);
